import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const individualReturn = async (payload) => {
  try {
    return await postRequest(`${urls.INDIVIDUAL_RETURN}`, payload);
  } catch (error) {
    return error;
  }
};
